import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import { useInstance, nextTick, createRef } from 'intact-vue-next';
import { useState } from '../../hooks/useState';
export function useInput(resetKeywords) {
  var component = useInstance();
  var keywords = useState('');
  var inputRef = createRef();
  function onInput(value) {
    keywords.set(_trimInstanceProperty(value).call(value));
    var dropdown = component.dropdownRef.value;
    // the position may be flip, and the select input height may change height too,
    // so we should reset the position
    nextTick(function () {
      dropdown.focusFirst();
      dropdown.position();
    });
  }
  // if menu showed and value changed on multiple mode
  // focus the input
  function focusInput() {
    if (component.get('filterable')) {
      inputRef.value.focus();
    }
  }
  component.on('$changed:show', function (show) {
    if (show) {
      focusInput();
      resetKeywords(keywords);
    } else if (component.get('multiple')) {
      resetKeywords(keywords);
    }
  });
  component.on('$changed:value', function () {
    var _component$get = component.get(),
      multiple = _component$get.multiple,
      filterable = _component$get.filterable;
    if (multiple && filterable) {
      focusInput();
      /**
       * don't reset keywords on multiple mode for continue selection
       * https://github.com/ksc-fe/kpc/issues/983
       */
      // resetKeywords(keywords);
    }
  });
  return {
    onInput: onInput,
    keywords: keywords,
    inputRef: inputRef
  };
}